import * as React from "react";
import type { SVGProps } from "react";
const SvgImageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.4 21.6 15.6 12l4.8 4.8m-15 4.8h12A3.6 3.6 0 0 0 21 18v-7.2M5.4 21.6A3.6 3.6 0 0 1 1.8 18V6a3.6 3.6 0 0 1 3.6-3.6h7.8m9 4.8-2.4-2.4m0 0-2.4-2.4m2.4 2.4-2.4 2.4m2.4-2.4 2.4-2.4M9 7.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageX;
